import { getAppBaseUrl } from './getAppBaseUrl'
import { getInternalAdminBaseUrl } from './getInternalAdminBaseUrl'
import { getWWWBaseUrl } from './getWWWBaseUrl'

export const APP_BASE_URL = getAppBaseUrl()
export const WWW_BASE_URL = getWWWBaseUrl()
export const INTERNAL_ADMIN_BASE_URL = getInternalAdminBaseUrl()
